import Rule from './rule';

export default class SuffixRule extends Rule {
  constructor(ruleText, attribute,active) {
    super(ruleText, attribute,active);
    this.ruleType = 'SUFFIX';
    this.compile(ruleText);
  }

  compile(text) {
    this.args = [text.replace(/^\s?suffix\s?/i, '') || null];
  }

  run(input, headers, resolve) {
    const arg = headers.includes(this.args[0]) ? resolve(this.args[0]) : this.args[0];
    return `${arg}${input}`;
  }

  validate() {
    return !!this.args && this.args.length === 1 && this.args[0] !== null;
  }
}
